import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { UserDetail } from 'api'
import { userDetailsSelector } from 'selectors/userSelectors'
import { DataGrid, GridId } from 'view/components/datagrid'
import { usersColumnDefs, usersGridOptions } from './UsersGridModel'
import { EnabledUsersFilterSwitch } from 'view/components/datagrid/toolbar/EnabledUsersFilterSwitch'

interface UsersGridProps {
  userList: UserDetail[]
}

const mapStateToProps = createStructuredSelector({
  userList: userDetailsSelector
})

export const UsersGridComponent: React.FunctionComponent<UsersGridProps> = props => {
  return (
    <DataGrid
      gridId={GridId.AdminUserGrid}
      customToolbarSwitches={[EnabledUsersFilterSwitch]}
      gridOptions={usersGridOptions}
      rowData={props.userList}
      columnDefs={usersColumnDefs}
    />
  )
}

export const UsersGrid = connect(mapStateToProps)(UsersGridComponent)
